import type { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";

export function Card({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={cn("panel", className)}>{children}</div>;
}

export function CardSection({
  eyebrow, title, description, actions, className, children,
}: {
  eyebrow?: string;
  title?: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
  children?: ReactNode;
}) {
  return (
    <section className={cn("flex flex-col gap-5", className)}>
      {(eyebrow || title || actions) && (
        <header className="flex items-start justify-between gap-4">
          <div className="flex flex-col gap-1">
            {eyebrow && <span className="label-eyebrow text-accent/80">{eyebrow}</span>}
            {title && <h2 className="text-lg font-semibold text-haze-100">{title}</h2>}
            {description && (
              <p className="text-sm text-haze-300 leading-relaxed max-w-2xl">{description}</p>
            )}
          </div>
          {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
        </header>
      )}
      {children}
    </section>
  );
}
